import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import JoditEditorComponent from "jodit-react";
import UploadLogo from "../../assets/images/upload.png"
import * as bannerAction from "../../redux/banner/bannerAction";

const CreateMobileBanner = () => {
  const [btnAction, setBtnAction] = useState("");
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedFile, setSelectedFile] = useState([]);
  const [mediaType, setMediaType] = useState("image");

  const handleSelectImage = (e) => {
    const chosenFiles = Array.prototype.slice.call(e.target.files);
    setSelectedFile(chosenFiles);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    try {
      dispatch(
        bannerAction.createBanner(
          {
            mediaType: mediaType
          },
          selectedFile,
          history
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleGridView = () => {
    const numberOfColumns = Math.max(2, Math.ceil(selectedFile.length / 2));
    let gridFr = [];
    for (let i = 0; i < numberOfColumns; i++) {
      gridFr.push("1fr");
    }
    return gridFr.join(" ");
  };

  const handleCancel = (e) => {
    e.preventDefault()
    history.goBack()
  }
  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> Create Banner </h3>
      </div>
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Enter new banner details</h4>

              <form className="form-sample">
                <div className="row">
                  <div className="col-xl-3 col-lg-5 col-md-5 col-sm-12 mb-4">
                    <div className="row">
                      <div className="col-12 d-flex flex-column">
                        <div className="d-flex align-items-center mb-2">
                          <p className="mb-0 mr-3">Media Type:</p>
                          <div className="form-check form-check-inline mr-3 mt-0">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                className="form-check-input"
                                name="mediaType"
                                value="image"
                                checked={mediaType === "image"}
                                onChange={(e) => {
                                  setMediaType(e.target.value);
                                  setSelectedFile([]); // clear selected files on type change
                                }}
                              />
                              Image
                              <i className="input-helper"></i>
                            </label>
                          </div>
                          <div className="form-check form-check-inline mt-0">
                            <label className="form-check-label">
                              <input
                                type="radio"
                                className="form-check-input"
                                name="mediaType"
                                value="video"
                                checked={mediaType === "video"}
                                onChange={(e) => {
                                  setMediaType(e.target.value);
                                  setSelectedFile([]); // clear selected files on type change
                                }}
                              />
                              Video
                              <i className="input-helper"></i>
                            </label>
                          </div>
                        </div>

                        <p>Add Banner {mediaType === "video" ? "Video" : "Image"}</p>
                        <div className="product-img-upload">
                          <div
                            style={
                              selectedFile?.length > 0
                                ? {
                                  display: "grid",
                                  gap: "10px",
                                  gridTemplateColumns: handleGridView(),
                                }
                                : { display: "block" }
                            }
                          >
                            {selectedFile?.map((item, i) => {
                              return (
                                <React.Fragment key={i}>
                                  {mediaType === "video" ? (
                                    <video
                                      className="w-100"
                                      style={{ aspectRatio: "4/3", backgroundColor: "#000" }}
                                      src={URL.createObjectURL(item)}
                                      controls
                                    />
                                  ) : (
                                    <img
                                      className="w-100"
                                      style={{ aspectRatio: "4/3" }}
                                      src={URL.createObjectURL(item)}
                                      alt="banner"
                                    />
                                  )}
                                </React.Fragment>
                              );
                            })}
                            {!selectedFile.length > 0 ? (
                              <img
                                className="w-100 h-100"
                                src={UploadLogo}
                                alt="profile"
                                srcset=""
                              />
                            ) : (
                              ""
                            )}
                            <button className="primary-btn upload-new-product-img w-100">
                              <input
                                type="file"
                                multiple={mediaType === "image"} // Only allow multiple for images usually, or adjust as needed
                                value=""
                                accept={mediaType === "video" ? "video/*" : "image/*"}
                                onChange={(e) => handleSelectImage(e)}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 mb-4">
                    <div className="row">
                      <div className="col-12">
                        <div className="form-group">
                          <label for="exampleInputUsername1">
                            ProductId for Button Action
                          </label>
                          <input
                            onChange={(e) => {
                              setBtnAction(e.target.value);
                            }}
                            placeholder="Enter ProductId for Button Action"
                            type="text"
                            id="exampleInputUsername1"
                            className="form-control form-control-lg"
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="btn btn-primary mr-2"
                >
                  Submit
                </button>
                <button className="btn btn-light" onClick={(e) => handleCancel(e)}>Cancel</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateMobileBanner;
